// assets
import BusinessIcon from '@mui/icons-material/Business';
import ContactsIcon from '@mui/icons-material/Contacts';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

// type
import ERoutes from 'routes/ERoutes';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - BUSINESS ||============================== //

const business: NavItemType = {
    id: 'business',
    title: 'Business',
    icon: BusinessIcon,
    type: 'group',
    url: ERoutes.businessList,
    children: [
        {
            id: 'businesses',
            title: 'Businesses',
            type: 'item',
            icon: BusinessIcon,
            url: ERoutes.businessList,
            breadcrumbs: false
        },
        {
            id: 'crm-contacts',
            title: 'Contacts',
            type: 'item',
            icon: ContactsIcon,
            url: ERoutes.crmContacts,
            breadcrumbs: false
        },
        {
            id: 'crm-duplicates',
            title: 'Duplicates',
            type: 'item',
            icon: ContentCopyIcon,
            url: ERoutes.crmDuplicates,
            breadcrumbs: false
        },
        {
            id: 'business-onboarding',
            title: 'Onboarding',
            type: 'item',
            icon: FactCheckIcon,
            url: ERoutes.businessOnboarding,
            breadcrumbs: false
        },
        {
            id: 'business-deletion-requests',
            title: 'Deletion Requests',
            type: 'item',
            icon: DeleteForeverIcon,
            url: ERoutes.businessDeletionRequests,
            breadcrumbs: false,
            roles: ['superAdmin']
        },
        {
            id: 'branded-app-requests',
            title: 'Branded mobile app requests',
            type: 'item',
            icon: PhoneIphoneIcon,
            url: ERoutes.brandedAppRequests,
            breadcrumbs: false,
            roles: ['superAdmin', 'developer']
        }
    ]
};

export default business;
